module.exports = {"230203002":"中华街道","230203004":"西大桥街道","230203005":"卜奎街道","230203006":"建设街道","230203007":"文化街道","230203198":"区直辖村级区划"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230203.json
// module id = 780
// module chunks = 0